<template>
  <a-locale-provider :locale="zh_CN">
    <div>
      <!-- 添加物品 -->
      <a-modal
        centered
        title="添加物品"
        v-model="visible"
        @ok="submit"
        @cancel="onCancel"
        :maskClosable="false"
        width="50%"
      >
        <data-table class="table-custom" ref="goodsTable" :option="option" />
      </a-modal>
    </div>
  </a-locale-provider>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "GoodsAdd",
  components: { DataTable },
  props: {
    WarehouseId: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    update: {
      type: Function
    }
  },
  data() {
    return {
      zh_CN,
      visible: false,
      option: {},
      dataList: []
    };
  },
  created() {
    this.visible = true;
    this.option = {
      //搜索框内容
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "类别",
            name: "GoodCategoryId",
            type: "select",
            api: "Common_GetSelect",
            param: {
              Types: "GoodsCategory"
            },
            dataField: "Data.GoodsCategory"
          },
          {
            label: "物品",
            name: "Keyword"
          }
        ],
        onSubmitBefore: values => {
          values.Status = values.Status ? null : 1;
          return values;
        }
      },
      //表格内容
      grid: {
        api: "Warehouse_GoodsGet", //数据表格api
        rowSelect: true,
        params: {
          WarehouseId: this.WarehouseId,
          DisplayZeroStock: this.type == "instock" ? true : false
        },
        columns: [
          {
            title: "物品名称",
            dataIndex: "GoodsName",
            width: "50%",
            align: "center"
          },
          {
            title: "单位",
            width: "10%",
            dataIndex: "UnitName",
            align: "center"
          },
          {
            title: "库存数量",
            dataIndex: "Quantity",
            width: "20%",
            align: "center"
          },
          {
            title: "库存均价",
            width: "20%",
            dataIndex: "AvgPrice",
            align: "right"
          }
        ]
      }
    };
  },
  methods: {
    onCancel() {
      this.visible = false;
      this.$emit("destroy");
    },
    submit() {
      let selecteds = this.$refs.goodsTable.getSelecteds();
      selecteds = selecteds.map(v => {
        v.Quantity = 0;
        v.UnitPrice = v.AvgPrice;
        v.TotalPrice = 0;
        v.GoodsUnitName = v.UnitName;
        v.isAdd = true;
        return v;
      });
      this.$emit("update", selecteds);
      this.visible = false;
      this.$emit("destroy");
    }
  }
};
</script>

<style lang="less" scoped>
.data-table {
  min-height: 450px;
  height: 450px;
}
</style>
